import { ActionType } from "../types/paymentTypes";
export var getPayment = function () { return ({
    type: ActionType.GET_PAYMENT,
}); };
export var getPaymentSuccess = function (invoice) { return ({
    type: ActionType.GET_PAYMENT_SUCCESS,
    payload: invoice,
}); };
export var getPaymentClear = function (invoice) { return ({
    type: ActionType.GET_PAYMENT_CLEAR,
    payload: invoice,
}); };
export var getPaymentError = function (error) { return ({
    type: ActionType.GET_PAYMENT_ERROR,
    payload: error,
}); };
